export default __webpack_public_path__ + "static/media/logo-postnl.1ec9ad8d.svg";